

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls,apiHostUrl } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const effectiveDateApi = createApi({
    reducerPath: 'effectivedate',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers);
        }
        
    }),
    endpoints: (builder) => ({
        getEffectiveDateByName: builder.query({
            query: (payload) => ({
                url: apiUrls?.itpNsaEffectiveDateUrl,
                method: 'POST',
                body: payload
            })
        }),
    }),

})

export const { useGetEffectiveDateByNameQuery } = effectiveDateApi;